import CloseIcon from '@mui/icons-material/Close';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { DialogActions, DialogContent, DialogTitle, Paper, Stack, Typography } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { BUOrder } from 'wisestep-api';
import { WsButton, WsColors, WsDialog, WsTypography, WsTypoVariants } from 'wisestep-base';

import { IBusinessData } from '../customizeStageStatus/helper';

interface OrderBUDefinitionProps {
  data: IBusinessData[];
  onSave: (result: BUOrder[]) => void;
  open: boolean;
  onClose?: () => void;
}
const OrderBUDefinition = ({ data, open, onSave, onClose = () => {} }: OrderBUDefinitionProps) => {
  const [ite, setItems] = useState<IBusinessData[]>(data);
  const createReOrderedList = (list: IBusinessData[]) =>
    list.map((BU) => {
      return { id: BU.id, displayOrder: BU.displayOrder };
    });
  const [orderList, setOrderList] = useState<BUOrder[]>(createReOrderedList(data));
  const reorder = (list, startIndex, endIndex) => {
    const result = list;
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };
  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    const items = reorder(ite, result.source.index, result.destination.index);
    setItems(items);
    setOrderList(
      items.map((BU, index) => {
        return { id: BU.id, displayOrder: index };
      })
    );
  };
  const onSubmit = async () => {
    await onSave(orderList);
    onClose();
  };
  return (
    <WsDialog openDialog={open} onClose={onClose} size={'small'}>
      <DialogTitle>
        <Stack direction="row" justifyContent="space-between">
          <WsTypography variant={WsTypoVariants.TITLE} bold={true}>
            Rearrange Business Definition
          </WsTypography>
          <CloseIcon sx={{ cursor: 'pointer' }} fontSize={'medium'} onClick={onClose} />
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ background: WsColors.BorderGrey, p: 4 }}>
        <Paper sx={{ mt: 4, p: 4, borderRadius: 2 }}>
          <Typography color={WsColors.TertiaryShades900} fontWeight={700} variant="body1">
            Rearrange order
          </Typography>

          <Table aria-label="simple table" sx={{ mt: 1 }}>
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="droppable">
                {(provided: any) => (
                  <TableBody
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    // style={getListStyle(snapshot.isDraggingOver)}
                    sx={{
                      background: WsColors.White,
                    }}
                  >
                    {ite.map((row, index) => (
                      <Draggable key={row.id} draggableId={row.id} index={index}>
                        {(provided: any) => (
                          <TableRow
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            // style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                            sx={{
                              // some basic styles to make the items look a bit nicer
                              userSelect: 'none',
                              // change background colour if dragging
                              // styles we need to apply on draggables
                              ...provided.draggableProps.style,
                              '&:last-child td, &:last-child th': { border: 0 },

                              background: WsColors.White,
                            }}
                            key={index}
                            draggable={true}
                          >
                            <TableCell
                              sx={{
                                border: 'none',
                                background: WsColors.White,
                                p: 0.5,
                                py: 1.2,
                              }}
                            >
                              <Stack direction="row">
                                <DragIndicatorIcon />
                                <WsTypography>{row.businessDefinitionName}</WsTypography>
                              </Stack>
                            </TableCell>
                          </TableRow>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </TableBody>
                )}
              </Droppable>
            </DragDropContext>
          </Table>
        </Paper>
      </DialogContent>
      <DialogActions>
        <WsButton onClick={onSubmit}>Save</WsButton>
      </DialogActions>
    </WsDialog>
  );
};

export default OrderBUDefinition;
